import { Controller, FieldValues, useFormState } from 'react-hook-form';
import { Checkbox } from '@heroui/react';
import { FormCheckboxProps } from './types';

const FormCheckbox = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  isRequired = false,
  isDisabled = false,
  description,
  className,
  showErrorOnTouched = true,
  ...rest
}: FormCheckboxProps<TFieldValues>) => {
  const { touchedFields, errors, isSubmitted } = useFormState({ control });
  const fieldError = errors[name]?.message as string | undefined;
  const isTouched = touchedFields[name];
  const showError = showErrorOnTouched ? (isTouched || isSubmitted) && !!fieldError : !!fieldError;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Checkbox
          {...rest}
          isSelected={field.value || false}
          onValueChange={field.onChange}
          isRequired={isRequired}
          isDisabled={isDisabled}
          description={description}
          className={className}
          isInvalid={showError}
          errorMessage={showError ? fieldError : undefined}
        >
          {label}
        </Checkbox>
      )}
    />
  );
};

FormCheckbox.displayName = 'FormCheckbox';

export default FormCheckbox;
